import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const borderRadius = '0.705rem'

const marginTB = '0.705rem'
const marginLR = '1.25rem'
const margin = `${marginTB} ${marginLR}`

type StylesType = {
  inModal: boolean
  onDetails: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    margin,
    fontSize: theme.size.sm,

    [theme.breakpoints.down('md')]: {
      margin: ({ inModal }) => (inModal ? `${marginTB} -1rem` : margin)
    }
  },

  rootYours: {
    flexDirection: 'row-reverse'
  },

  avatar: {
    alignSelf: 'flex-start',
    margin: '0 10px',
    width: '2rem',
    height: '2rem',
    textTransform: 'capitalize',
    fontSize: theme.size.sm,
    padding: '0.125rem',

    '& > img': {
      borderRadius: '100%'
    }
  },

  avatarRoot: {
    alignSelf: 'baseline'
  },

  comment: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px'
  },

  commentYours: {
    alignItems: 'flex-end',
    marginLeft: '0',
    marginRight: '10px'
  },

  content: {
    marginBottom: '5px',
    border: '2px solid #F1F1F1',
    borderRadius,
    borderTopLeftRadius: '0',
    boxSizing: 'border-box',
    width: 'max-content',
    whiteSpace: 'pre-wrap',
    maxWidth: ({ onDetails }) => (onDetails ? '55vw' : '18.75rem'),
    padding: '0.705rem',
    overflowWrap: 'anywhere',
    fontSize: theme.size.sm,
    backgroundColor: 'white',
    color: '#323436',

    '& span': {
      margin: '0 1px',
      padding: '0.05rem 0.4rem',
      borderRadius: borderRadius
    }
  },

  contentYours: {
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: '0'
  },

  contentHolder: {
    display: 'flex',
    alignItems: 'center'
  },

  contentHolderYours: {
    flexDirection: 'row-reverse'
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.3125rem',
    fontSize: theme.size.sm,
    color: '#7F8487'
  },

  footerYours: {
    justifyContent: 'flex-end'
  },

  name: {
    marginRight: '7px'
  },

  time: {
    display: 'flex',
    alignItems: 'center'
  },

  dots: {
    margin: '-3px 0 0 0.25rem',
    height: 'max-content',
    width: 'max-content',

    '& .dot': {
      fontSize: theme.size.lg,
      cursor: 'pointer',

      '&:hover': {
        color: theme.palette.primary.main
      }
    }
  },

  dotsYours: {
    margin: '-3px 0.25rem 0 0'
  },

  mention: {
    // @ts-ignore
    background: theme.palette.avatarBackground,
    // @ts-ignore
    color: theme.palette.textLight
  },

  mentionYou: {
    background: theme.palette.primary.main,
    color: '#FFFFFF'
  },

  editInput: {
    outline: 'none',
    border: 'none',
    fontSize: 'inherit',
    padding: 0,
    width: '100%',
    background: 'transparent',
    resize: 'none',
    color: '#323436'
  }
}))

export default useStyles
